/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ServizioListItemDTO } from './servizio-list-item-dto';


export interface PagedModelServizioListItemDTO { 
    content?: Array<ServizioListItemDTO>;
    page?: PageMetadata;
}

